import { Scene } from "phaser";
import { beagleJorney, getResolution } from "../lib/config";

export class Preloader extends Scene {
  constructor() {
    super("Preloader");
  }

  init() {
    //  We loaded this image in our Boot Scene, so we can display it here
    const { width, height } = getResolution();
    //  A simple progress bar. This is the outline of the bar.
    this.add
      .rectangle(width / 2, height / 2, 468, 32)
      .setStrokeStyle(1, 0xffffff);

    //  This is the progress bar itself. It will increase in size from the left based on the % of progress.
    const bar = this.add.rectangle(
      width / 2 - 230,
      height / 2,
      4,
      28,
      0xffffff
    );

    //  Use the 'progress' event emitted by the LoaderPlugin to update the loading bar
    this.load.on("progress", (progress: number) => {
      //  Update the progress bar (our bar is 464px wide, so 100% = 464px)
      bar.width = 4 + 460 * progress;
    });
  }

  preload() {
    //  Load the assets for the game - Replace with your own assets
    this.load.setPath("assets");
    // Interface
    this.load.image("share", "interface/ShareOFF.png");
    this.load.image("shareOn", "interface/ShareON.png");
    this.load.image("next", "interface/BotonAdelante.png");
    this.load.image("prev", "interface/BotonAtras.png");
    this.load.image("nextOn", "interface/NextON.png");
    this.load.image("prevOn", "interface/BackON.png");
    this.load.image("fb", "interface/FacebookOFF.png");
    this.load.image("fbOn", "interface/FacebookON.png");
    this.load.image("wapp", "interface/WhatsappOFF.png");
    this.load.image("wappOn", "interface/WhatsappON.png");
    this.load.image("twitter", "interface/XOFF.png");
    this.load.image("twitterOn", "interface/XON.png");
    this.load.image("restartBtnOff", "interface/ReinicioOFF.png");
    this.load.image("restartBtnOn", "interface/ReinicioON.png");
    this.load.image("fson", "interface/fson.png");
    this.load.image("fullscreenOff", "interface/FullscreenOFF.png");
    this.load.image("jpgMap", "interface/jpgMap.jpg");
    // Horizontal Postal
    this.load.image("postal1", "horizontal-postal/Postal1.jpg");
    this.load.image("postal2", "horizontal-postal/Postal2.jpg");
    this.load.image("postal3", "horizontal-postal/Postal3.jpg");
    this.load.image("postal4", "horizontal-postal/Postal4.jpg");
    this.load.image("postal5", "horizontal-postal/Postal5.jpg");
    this.load.image("postal6", "horizontal-postal/Postal6.jpg");
    this.load.image("postal7", "horizontal-postal/Postal7.jpg");
    this.load.image("postal8", "horizontal-postal/Postal8.jpg");
    this.load.image("postal9", "horizontal-postal/Postal9.jpg");
    this.load.image("postal10", "horizontal-postal/Postal10.jpg");
    this.load.image("postal11", "horizontal-postal/Postal11.jpg");
    this.load.image("postal12", "horizontal-postal/Postal12.jpg");
    this.load.image("postal13", "horizontal-postal/Postal13.jpg");
    this.load.image("postal14", "horizontal-postal/Postal14.jpg");
    this.load.image("postal15", "horizontal-postal/Postal15.jpg");
    this.load.image("postal16", "horizontal-postal/Postal16.jpg");
    this.load.image("postal17", "horizontal-postal/Postal17.jpg");
    this.load.image("postal18", "horizontal-postal/Postal18.jpg");
    // Verticasl Postal
    this.load.image("endbg", "menu-items/FondoFinal.jpg");
    beagleJorney.map((el) =>
      this.setTextComponent(el.waypoint.description, el.waypoint.name)
    );
    beagleJorney.map((el, index) =>
      this.makeWaypointTexture(`wp${index + 1}`, (index + 1).toString())
    );
  }

  create() {
    this.scene.start("MainMenu").remove();
  }

  setTextComponent(text: string, id: string) {
    let graphics = this.make.graphics();
    graphics.lineStyle(1, 0xff5c00);
    graphics.fillStyle(0xff5c00, 1);

    let textObject = this.add.text(0, 0, text, {
      fontSize: "20px",
      fontFamily: "Arial",
      fontStyle: "bold italic ",
      align: "left",
      padding: { left: 5, right: 0, y: 5 },
      resolution: 0,
    });
    let textWidth = textObject.width <= 130 ? 130 : textObject.width;
    let textHeight = textObject.height;

    graphics.strokeRoundedRect(10, 20, textWidth + 20, textHeight + 20, 10);
    graphics.fillRoundedRect(10, 20, textWidth + 20, textHeight + 20, 10);

    textObject.x = 15;
    textObject.y = 25;

    let renderTexture = this.add.renderTexture(
      9,
      19,
      textWidth + 30,
      textHeight + 40
    );

    renderTexture.draw(graphics);
    renderTexture.draw(textObject);

    renderTexture.saveTexture(id);

    graphics.destroy();
    textObject.destroy();
    renderTexture.destroy();
  }

  makeWaypointTexture(name: string, id: string) {
    const waypoint = this.add.graphics();
    waypoint.fillStyle(0xff5c00, 1); // Color rojo

    // Dibujar un círculo
    waypoint.fillCircle(14, 14, 14); // (x, y, radio)

    // Añadir texto dentro del círculo
    const text = this.add
      .text(14, 14, id, {
        fontSize: "16px",
        fontFamily: "Arial",
        fontStyle: "bold",
        fill: "#fff",
      })
      .setResolution(5);
    text.setOrigin(0.5, 0.5); // Centrar el texto en el círculo

    // Crear una textura a partir del gráfico y el texto
    const renderTexture = this.add.renderTexture(0, 0, 28, 28);
    renderTexture.draw(waypoint);
    renderTexture.draw(text);
    renderTexture.saveTexture(name);

    // Limpiar los gráficos y el texto ya que no son necesarios después de crear la textura
    waypoint.destroy();
    text.destroy();
    renderTexture.destroy();
  }
}
